import { createContext, useContext } from 'react'

type ListboxContextType = {
  id: string
  selectedOptionIds: string[]
  focusedOptionId: string | null
  onSelect: (id: string) => void
}

export const ListboxContext = createContext<ListboxContextType | undefined>(
  undefined
)

export const useListboxContext = () => useContext(ListboxContext)
